import {parseDate, sortDates} from "../../../../utilities";

export const columnsListenerTable =[
    {
        Header: "",
        accessor: "checked",
        editable: false,
        viewType:"checkbox",
    },
    {
        Header: "ФИО",
        accessor: "fio",
        editable: false,
        viewType:"text"
    },
    {
        Header: "Идент.номер заявителя",
        accessor: "persNum",
        editable: false,
        viewType:"text"
    },
    {
        Header: "Программа подготовки",
        accessor: "programName",
        editable: false,
        viewType:"text"
    },
    {
        Header: "Дата рождения",
        accessor: "birthDate",
        editable: false,
        viewType:"text",
        sortType: (rowA, rowB, columnId) => {
            const dateA = parseDate(rowA.values[columnId]);
            const dateB = parseDate(rowB.values[columnId]);

            return sortDates(dateA, dateB);
        },
    },
    {
        Header: "Период обучения с",
        accessor: "startDate",
        editable: false,
        typeEdit:"date",
        viewType:"text",
        sortType: (rowA, rowB, columnId) => {
            const dateA = parseDate(rowA.values[columnId]);
            const dateB = parseDate(rowB.values[columnId]);

            return sortDates(dateA, dateB);
        },
    },
    {
        Header: "Период обучения по",
        accessor: "endDate",
        editable: false,
        typeEdit:"date",
        viewType:"text",
        sortType: (rowA, rowB, columnId) => {
            const dateA = parseDate(rowA.values[columnId]);
            const dateB = parseDate(rowB.values[columnId]);

            return sortDates(dateA, dateB);
        },
    },


]